import { responsive, ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const selectEntity: ThemeUICSSObject = {
  /* PREPEND HERE */
  '.selectEntity__content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,

    h4: { overflow: 'hidden', textOverflow: 'ellipsis' },
    ul: {
      maxHeight: '208px',
      overflowX: responsive({ 0: 'hidden', 3: 'auto' }),
    },
    '[role="treeitem"][aria-selected="true"]': (theme) => {
      return {
        position: 'sticky',
        bottom: 0,
        top: 0,
        zIndex: 1,

        '.filteredMenu__item': {
          backgroundColor: () =>
            theme.palette.getStatesFromPath('palette.background.paper', {
              states: {
                active: false,
                checked: false,
                default: false,
                disabled: false,
                focus: false,
                hover: false,
                readonly: false,
                selected: true,
              },
            }),
        },
        '.filteredMenu__item:hover': {
          backgroundColor: () =>
            theme.palette.getStatesFromPath('palette.background.paper', {
              states: {
                active: false,
                checked: false,
                default: false,
                disabled: false,
                focus: false,
                hover: false,
                readonly: false,
                selected: true,
              },
            }),
        },
      };
    },
    '.selectProcess__filteredMenu__wrapper': {
      pt: 0,
      '.tree': {
        height: 'auto',
        maxHeight: '208px',
      },
    },

    '.selectEntity__filteredMenu__wrapper': {
      pb: 0,
      '.selectEntity__readonlyEntity': {
        p: 3,
        background: 'palette.action.disabled.light',
      },
      '.tree': {
        height: 'auto',
        maxHeight: '208px',
      },
      '.selectEntity__switchToProcess': {
        py: 0,
        justifyContent: 'end',
      },
    },
  },
};

export default selectEntity;
